import React, { useEffect, useRef, useState } from "react";
import '../../../src/pages/Website/webStyle.css'
import WebsiteNavbar from "./Navbar";
import Footer from "./footer";
import { getData, postData } from "src/webService/webService";
import { toast, ToastContainer } from "react-toastify";
import { Avatar, Box, Button, Dialog, DialogContent } from "@mui/material";
import hanger from '../../components/images/hanger.png';
import Loader from "../Loader/Loader";
import user from '../../components/icons/user-dark.png';
import location from '../../components/icons/location.png';
import Iconify from "src/components/iconify";
import whatsapp from '../../components/icons/whatsapp-32px.png';
import fb from '../../components/icons/fb.png';
import insta from '../../components/icons/instagram.png';
import website from '../../components/icons/website.png';
import twitter from '../../components/icons/twitter.png';
import Lightbox from "react-image-lightbox";
import 'react-image-lightbox/style.css';
import { Modal } from "reactstrap";
import productThumbnail from '../../components/icons/brand.png';
import { useParams } from "react-router-dom";


export default function SellerPage() {

    const [viewSeller, setViewSeller] = useState({});
    const [viewSellerProduct, setViewSellerProduct] = useState([]);
    const Token = sessionStorage.getItem('Token');
    const [loading, setLoading] = useState(false);
    const [isOpenGallery, setIsOpenGallery] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);
    const [selectedGallery, setSelectedGallery] = useState([]);
    const [open, setOpen] = useState(true);
    const [showSkip, setShowSkip] = useState(false);
    const skipTimerRef = useRef(null);
    const countdownIntervalRef = useRef(null);
    const [skipCountdown, setSkipCountdown] = useState(5);
    const [totalPages, setTotalPages] = useState(1)
    const [TotalItems, setTotalItems] = useState(null);
    const [limit, setLimit] = useState(5);
    const {id} = useParams();

    const handleClose = () => {
        clearTimeout(skipTimerRef.current);
        setOpen(false);
    };

    const handleOpen = () => {
        debugger;
        if (viewSeller?.intro_video === '' || viewSeller?.intro_video === undefined) {
            toast.error('Intro Video is not available')
        } else {
            setOpen(true);
        }
    }

    const handleVideoPlay = () => {
        // Start the 5-second timer once video actually starts playing
        skipTimerRef.current = setTimeout(() => {
            setShowSkip(true);
            setSkipCountdown(5);

        }, 5000);
    };

    useEffect(() => {
        countdownIntervalRef.current = setInterval(() => {
            setSkipCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(countdownIntervalRef.current);
                    setShowSkip(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    }, [])


    const handleNextPage = () => {
        debugger
        if (limit > totalPages) {
            setLimit(limit + 5)
        }
    };

    const getViewSeller = async () => {
        debugger;
        setLoading(true);

        try {
            const res = await getData(`buyer/seller/${id}`, null, Token);
            if (res.status === 200) {
                console.log(res.data, "res.data");
                setViewSeller(res.data);
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        } finally {
            setLoading(false);
        }
    }

    const getSellerProduct = async (page) => {
        debugger;
        setLoading(true);
        const params = {
            page: page,
            per_page: limit,
        }
        try {
            const res = await getData(`buyer/seller/${id}/products`, params, Token);
            if (res.status === 200) {
                console.log(res.data, "res.data");
                setViewSellerProduct(res.data);
                setTotalItems(res?.total);
                setTotalPages(res?.last_page);
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getViewSeller();
    }, [id]);


    useEffect(() => {
        getSellerProduct(1);
    }, [id, limit]);

    const openGallery = (images, index) => {
        setPhotoIndex(index);
        setIsOpenGallery(true);
        setSelectedGallery(images);
    };

    console.log(viewSeller?.intro_video, 'hdfhsohfoihsifhahiahoi');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    const contactSeller = async (id, status) => {
        let params = {};
    
        if (status === 'isCall') {
            params = { isCall: true };
        } else if (status === 'isChat') {
            params = { isChat: true };
        } else if (status === 'isCallback') {
            params = { isCallback: true };
        }
    
        try {
            const res = await postData(`buyer/seller/${id}`, params, Token);
            getSellerProduct(1);
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }
    


    return (
        <div>
            <WebsiteNavbar />
            <ToastContainer position="top-right" />
            <div className="Banner">
                <div className="w-50 d-flex justify-content-center align-items-center banner-title">
                    <h1>{viewSeller?.name||"Seller Profile"}</h1>
                </div>
            </div>

            <div>
                <div className="container mt-3">
                    <div className="row">
                        <div className="col-lg-12">
                            {loading ? (
                                <Loader />
                            ) : (
                                <div className='sellerCardLayout'>
                                    <div className="w-25">
                                        <img className="sellerCardLayoutImg" src={viewSeller?.profile_picture} />
                                    </div>
                                    <div className="d-flex w-75">
                                        <div className="w-100">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h4 style={{ fontWeight: '600' }} className='pt-1 mb-0 pb-1 pointer'>{viewSeller?.name}</h4>
                                                <div className="d-flex align-items-center desktop">
                                                    <div className="d-flex">
                                                        <p className="mb-0 categoryText"><Iconify style={{ marginRight: '10px', width: '16px' }} icon="eva:email-outline" />{viewSeller?.email}</p>
                                                    </div>
                                                    <div className="d-flex pointer" style={{ marginLeft: '12px' }} onClick={handleOpen}>
                                                        <p className="mb-0 categoryText"><Iconify style={{ marginRight: '10px', width: '16px' }} icon="eva:play-circle-outline" />Play Intro video</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex mt-2">
                                                <p className="mb-0" style={{fontSize: '14px'}}><Iconify style={{ marginRight: '10px', width: '16px' }} icon="eva:grid-outline" />{viewSeller?.category_names}</p>
                                            </div>
                                            <div className="mobile">
                                                <div className="d-flex" style={{ marginLeft: '3px' }}>
                                                    <p className="mb-0 categoryText"><Iconify style={{ marginRight: '10px', width: '16px' }} icon="eva:email-outline" />{viewSeller?.email}</p>
                                                </div>
                                                <div className="d-flex pointer mt-2" style={{ marginLeft: '3px' }} onClick={handleOpen}>
                                                    <p className="mb-0 categoryText"><Iconify style={{ marginRight: '10px', width: '16px' }} icon="eva:play-circle-outline" />Play Intro video</p>
                                                </div>
                                                <div className="d-flex mt-2" style={{ marginLeft: '3px' }}>
                                                    <p className="mb-0 categoryText"><Iconify style={{ marginRight: '10px', width: '16px' }} icon="eva:grid-outline" />{viewSeller?.category?.name}</p>
                                                </div>
                                            </div>
                                            <a style={{ textDecoration: 'none' }} href={viewSeller?.map_location} target="_blank"><p style={{ fontWeight: '600', fontSize: '14px' }} className='pt-0 mb-0 mt-2'><Iconify icon="eva:pin-outline" style={{ width: '16px', marginRight: '10px' }} />{viewSeller?.address}, {viewSeller?.location ? viewSeller?.location : 'No Location Found :('}</p></a>
                                            <div className="mt-2">
                                                <p style={{ fontSize: '14px', marginTop: '6px' }}><Iconify icon="eva:alert-circle-outline" style={{ width: '16px', marginRight: '10px' }} />{viewSeller?.aboutus ? viewSeller?.aboutus : 'Not Mentioned'}</p>
                                            </div>
                                            <div className="mt-3 d-flex justify-content-between align-items-center">
                                                <div className="d-flex">
                                                    <div onClick={(e) => contactSeller(viewSeller?._id, 'isCall')}>
                                                        <a href={`tel:${viewSeller?.phone}`} style={{ textDecoration: 'none' }}>
                                                            <Button variant="contained" style={{ background: '#058a07', boxShadow: 'none' }} startIcon={<Iconify icon="eva:phone-outline" />} className="d-flex align-items-center">
                                                                {/* {viewSeller?.phone_countrycode} {viewSeller?.phone} */}
                                                                Call
                                                            </Button>
                                                        </a>
                                                    </div>
                                                    <div style={{ marginLeft: '12px' }} onClick={(e) => contactSeller(viewSeller?._id, 'isChat')}>
                                                        <a
                                                            href={`https://wa.me/${viewSeller?.whatsapp}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ textDecoration: 'none' }}
                                                        >
                                                            <Button variant="outlined" className="d-flex align-items-center" style={{ padding: '4px 10px' }}>
                                                                <div className="d-flex justify-content-center align-items-center" style={{ width: '24%', marginRight: '10px' }}>
                                                                    <img width='100%' src={whatsapp} />
                                                                </div>
                                                                Whatsapp
                                                            </Button>
                                                        </a>
                                                    </div>
                                                </div>


                                                <div className="row">
                                                    <div className="col-lg-12 d-flex justify-content-end">
                                                        {viewSeller?.facebook_link && (
                                                            <a href={viewSeller.facebook_link} target="_blank">
                                                                <img width='50%' className="pointer" src={fb} />
                                                            </a>
                                                        )}
                                                        {viewSeller?.instagram_link && (
                                                            <a href={viewSeller.instagram_link} target="_blank">
                                                                <img width='50%' className="pointer" src={insta} />
                                                            </a>
                                                        )}
                                                        {viewSeller?.website_link && (
                                                            <a href={viewSeller.website_link} target="_blank">
                                                                <img width='50%' className="pointer" src={website} />
                                                            </a>
                                                        )}
                                                        {viewSeller?.twitter_link && (
                                                            <a href={viewSeller.twitter_link} target="_blank">
                                                                <img width='50%' className="pointer" src={twitter} />
                                                            </a>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {viewSeller?.intro_video ? (
                        <Dialog open={open} maxWidth="md">
                            <DialogContent sx={{ position: 'relative', p: 0 }}>
                                <Box position="relative">
                                    <video
                                        width="100%"
                                        autoPlay
                                        controls
                                        onPlay={handleVideoPlay}
                                        style={{ borderRadius: '8px' }}
                                    >
                                        <source
                                            src={viewSeller?.intro_video}
                                        />
                                    </video>

                                    {showSkip ? (
                                        <Button
                                            variant="contained"
                                            color="error"
                                            onClick={handleClose}
                                            sx={{
                                                position: 'absolute',
                                                top: 16,
                                                right: 16,
                                                backgroundColor: 'rgba(0,0,0,0.6)',
                                                color: '#fff',
                                                px: 2,
                                                py: 1,
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                            }}
                                        >
                                            Skip
                                        </Button>
                                    ) : (
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                top: 16,
                                                right: 16,
                                                backgroundColor: 'rgba(0,0,0,0.6)',
                                                color: '#fff',
                                                px: 2,
                                                py: 1,
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                            }}
                                        >
                                            Skip in {skipCountdown}...
                                        </Box>
                                    )}
                                </Box>
                            </DialogContent>
                        </Dialog>
                    ) : (
                        <></>
                    )}

                    <h4 style={{ fontWeight: '600' }} className="mt-3">Products</h4>
                    {loading ? (
                        <Loader />
                    ) : (
                        <div className="row">
                            {viewSellerProduct && viewSellerProduct.length > 0 ? (
                                viewSellerProduct.map((item, itemIndex) => (
                                    <div className="col-lg-6" key={itemIndex}>
                                        <div className='sellerCardLayout'>
                                            <div className="w-35">
                                                <img className="sellerCardLayoutImg" src={item?.thumbnail} />
                                            </div>
                                            <div className="w-65">
                                                <div>
                                                    <h4 style={{ fontWeight: '600' }}>{item?.name}</h4>
                                                    <p className="mb-0 px-1 categoryText">
                                                        {item?.description || 'Description not mentioned'}
                                                    </p>
                                                </div>
                                                <div className="mt-2">
                                                    <p style={{ marginBottom: '4px', fontSize: '14px' }}>
                                                        <strong>Fabric Type:</strong> {item?.fabric_type || 'Not Available'}
                                                    </p>
                                                    <p style={{ marginBottom: '4px', fontSize: '14px' }}>
                                                        <strong>Colors:</strong> {item?.colors || 'Not Available'}
                                                    </p>
                                                    <p style={{ marginBottom: '4px', fontSize: '14px' }}>
                                                        <strong>Size:</strong> {item?.sizes || 'Not Available'}
                                                    </p>
                                                </div>

                                                <div className="d-flex align-items-center">
                                                    {item?.galleryFiles?.length > 0 ? (
                                                        item.galleryFiles.map((image, imageIndex) => (
                                                            <div key={imageIndex} style={{ position: "relative", margin: "2px" }}>
                                                                <Avatar
                                                                    src={image}
                                                                    sx={{
                                                                        height: "35px",
                                                                        width: "35px",
                                                                        borderRadius: "10%",
                                                                        cursor: "pointer",
                                                                    }}
                                                                    onClick={() => openGallery(item.galleryFiles, imageIndex)}
                                                                />
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div style={{ fontStyle: "italic", color: "#999", marginTop: '12px' }}>No gallery images available</div>
                                                    )}
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                ))
                            ) : (
                                <div className="col-12 text-center mt-5">
                                    <div className="d-flex justify-content-center align-items-center">
                                        <img width='100' src={productThumbnail} />
                                    </div>
                                    <p>No products available</p>
                                </div>
                            )}
                            {TotalItems <= limit ? (
                                <></>
                            ) : (
                            <div className="d-flex justify-content-center mt-5 align-items-center">
                                <Button variant="contained" className='Button' onClick={handleNextPage}
                                    disabled={TotalItems <= limit}>Load More</Button>
                            </div>
                            )}

                            {TotalItems <= limit ? (
                                <div className="mt-5">
                                    <p className="text-center fw-bold text-uppercase">To explore more products, please click the button below.</p>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <Button variant="contained" className='Button'  onClick={(e) => contactSeller(viewSeller?._id, 'isCallback')} startIcon={<Iconify icon="eva:phone-outline" />}
                                            >Call Back</Button>
                                    </div>
                                </div>
                            ) : (
                                <></>
                            )}

                            {/* LIGHTBOX */}
                            {isOpenGallery && (
                                <Lightbox
                                    mainSrc={selectedGallery[photoIndex]}
                                    nextSrc={selectedGallery[(photoIndex + 1) % selectedGallery.length]}
                                    prevSrc={selectedGallery[(photoIndex + selectedGallery.length - 1) % selectedGallery.length]}
                                    onCloseRequest={() => setIsOpenGallery(false)}
                                    onMovePrevRequest={() =>
                                        setPhotoIndex((photoIndex + selectedGallery.length - 1) % selectedGallery.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setPhotoIndex((photoIndex + 1) % selectedGallery.length)
                                    }
                                />
                            )}
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </div>
    )
}